module.exports = __webpack_public_path__ + "static/media/IMG-9.2d8432be.jpg";